/**
 * randomString generates a random string of specified
 * @param length
 * @param characters - charset to be used.
 */
export const randomString = (
  length: number,
  characters: string = 'abcdefghijklmnopqrstuvwxyz0123456789'
) => {
  let result = '';
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}

